module.exports = __webpack_public_path__ + "static/media/der.543f7cad.jpg";